import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ContenedoresService {

  server: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/contenedores";
    this.token = this.auth.getToken();
  }

  getContenedores(estado: string) {
    return this.httpClient.get(this.server+'/'+estado);
  }

  getContenedor(id: number) {
    return this.httpClient.get(this.server+'/contenedor/'+id);
  }

  newContenedor(matricula: string, matricula_old: string, medidas: string, tipo: string, estado: string, observaciones: string) {
    const formData = new FormData();
    formData.append('matricula', matricula);
    formData.append('matricula_old', matricula_old);
    formData.append('medidas', medidas);
    formData.append('tipo', tipo);
    formData.append('estado', estado);
    formData.append('observaciones', observaciones);
    return this.httpClient.post(this.server, formData);
  }

  editContenedor(id: number, matricula: string, matricula_old: string, medidas: string, tipo: string, estado: string, observaciones: string) {
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('matricula', matricula);
    formData.append('matricula_old', matricula_old);
    formData.append('medidas', medidas);
    formData.append('tipo', tipo);
    formData.append('estado', estado);
    formData.append('observaciones', observaciones);
    return this.httpClient.post(this.server+"/update", formData);
  }

  deleteContenedor(id: number){
    return this.httpClient.delete(this.server+"/"+id);
  }

  /* TIPOS */
  getTiposContenedores() {
    return this.httpClient.get(this.server+'/tipos/get');
  }

  newTipoContenedor(nombre: string) {
    const formData = new FormData();
    formData.append('nombre', nombre);
    return this.httpClient.post(this.server+'/tipos', formData);
  }

  updateTipoContenedor(id: number, nombre: string) {
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('nombre', nombre);
    return this.httpClient.post(this.server+"/tipos/update", formData);
  }

  deleteTipoContenedor(id: number){
    return this.httpClient.delete(this.server+"/tipos/delete/"+id);
  }


  /* Mantenimientos */
  getMantenimientosContenedores(contenedorID: string = 'all', tipo: string = 'all', active: string = 'all') {
    return this.httpClient.get(this.server+'/mantenimientos/'+contenedorID+'/'+tipo+'/'+active);
  }

  newMantenimiento(contenedor: number, tipo: string, fechaAlta: string, fechaAccion: string, coste: string, observaciones: string, estado: string) {
    const formData = new FormData();
    formData.append('contenedor', contenedor.toString());
    formData.append('tipo', tipo);
    formData.append('fechaAlta', fechaAlta);
    formData.append('fechaAccion', fechaAccion);
    formData.append('coste', coste);
    formData.append('observaciones', observaciones);
    formData.append('estado', estado);
    return this.httpClient.post(this.server+"/mantenimientos", formData);
  }

  updateMantenimiento(mantenimiento: number, contenedor: number, tipo: string, fechaAlta: string, fechaAccion: string, coste: string, observaciones: string, estado: string) {
    const formData = new FormData();
    formData.append('mantenimiento', mantenimiento.toString());
    formData.append('contenedor', contenedor.toString());
    formData.append('tipo', tipo);
    formData.append('fechaAlta', fechaAlta);
    formData.append('fechaAccion', fechaAccion);
    formData.append('coste', coste);
    formData.append('observaciones', observaciones);
    formData.append('estado', estado);
    return this.httpClient.post(this.server+"/mantenimientos/update", formData);
  }

  deleteMantenimiento(id: number){
    return this.httpClient.delete(this.server+"/mantenimientos/"+id);
  }

  /* Movimientos */
  getMovimientosContenedores(contenedorID: string = 'all', tipo: string = 'all', albaranNum: string = 'all') {
    return this.httpClient.get(this.server+'/movimientos/'+contenedorID+'/'+tipo+'/'+albaranNum);
  }
  
  newMovimiento(tipo: string, contenedorEntrega: number, contenedorRetirada: number, fecha: string, albaran: number, observaciones: string, cliente: string, latitud: string, longitud: string){
    const formData = new FormData();
    formData.append('tipo', tipo);
    formData.append('contenedorEntrega', contenedorEntrega.toString());
    formData.append('contenedorRetirada', contenedorRetirada.toString());
    formData.append('fecha', fecha);
    formData.append('albaran', albaran.toString());
    formData.append('observaciones', observaciones);
    formData.append('cliente', cliente);
    formData.append('latitud', latitud);
    formData.append('longitud', longitud);
    return this.httpClient.post(this.server+"/movimientos", formData);
  }

  updateMovimiento(movimiento: number, tipo: string, contenedorEntrega: number, contenedorRetirada: number, fecha: string, albaran: number, observaciones: string, cliente: string, latitud: string, longitud: string){
    const formData = new FormData();
    formData.append('movimiento', movimiento.toString());
    formData.append('tipo', tipo);
    formData.append('contenedorEntrega', contenedorEntrega.toString());
    formData.append('contenedorRetirada', contenedorRetirada.toString());
    formData.append('fecha', fecha);
    formData.append('albaran', albaran.toString());
    formData.append('observaciones', observaciones);
    formData.append('cliente', cliente);
    formData.append('latitud', latitud);
    formData.append('longitud', longitud);
    return this.httpClient.post(this.server+"/movimientos/update", formData);
  }

  deleteMovimiento(id: number){
    return this.httpClient.delete(this.server+"/movimientos/"+id);
  }

  /* IMAGES */
  uploadImage(formData) {
    return this.httpClient.post<any>(this.server+"/image/upload", formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  getImages(tipo: string, id: number) {
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('tipo', tipo);
    return this.httpClient.post(this.server+"/images", formData);
  }

  deleteImage(tipo: string, id: number){
    return this.httpClient.delete(this.server+"/image/delete/"+tipo+"/"+id);
  }

}
